/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cloud_logic_custom": [
        {
            "name": "datauiRestAPI",
            "endpoint": "https://hvy7uksai0.execute-api.eu-central-1.amazonaws.com/demo",
            "region": "eu-central-1"
        }
    ],
    "aws_user_files_s3_bucket": "vnr-dataui-demo-cache",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
